module.exports = __webpack_public_path__ + "img/avatar1.0e13e709.png";